export const magnetMixin = {
    methods: {
        startjaar: function(mod) {
            return Number(mod.jaar) + Number(mod.start);
        },
        eindjaar: function(mod) {
            return Number(mod.jaar) + Number(mod.eind);
        },
        strength: function(mod,jaar) {
            if (jaar < this.startjaar(mod) || jaar > this.eindjaar(mod)) return null;
            return mod.jaar - jaar;
        },
        createMagnet(modjaar, start, eind, active = true) {
            var moderator = {
              jaar: modjaar,
              start: start,
              eind: eind,
              active: active,
              type: "magnet"
            };
            //
            return moderator;
          },
    },
    
}
 